import BackButton from "@/features/shared/components/back-button";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account")({
  component: AccountLayout
});

function AccountLayout() {
  return (
    <div className="block w-full max-w-full pt-0 md:flex md:items-start md:justify-center">
      <div className="container mx-auto space-y-10 px-4 py-4 md:py-8">
        <BackButton />
        <Outlet />
      </div>
    </div>
  );
}
